export const initialState = {
    error: null,
    fetching: false,
    members: null,
  }
  
  export default function(state = initialState, action) {
    switch(action.type) {
      case 'SET_TEAM_MEMBERS_ERROR': {
        return {
          ...state,
          error: action.payload
        }
      }
      case 'SET_TEAM_MEMBERS_FETCH_STATUS': {
        return {
          ...state,
          fetching: action.payload
        }
      }
      case 'SET_TEAM_MEMBERS': {
        return {
          ...state,
          members: action.payload
        }
      }
    }
    return state
  }